import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function PlusAlt(props: IconProps) {
  return (
    <IconSvg {...props}>
      <polygon points="2 21.4308617 2 15.0180361 14.6332665 15.0180361 14.6332665 2 21.3026052 2 21.3026052 15.0180361 34 15.0180361 34 21.4308617 21.3026052 21.4308617 21.3026052 34.4488978 14.6332665 34.4488978 14.6332665 21.4308617"></polygon>
    </IconSvg>
  );
}
